import { createContext, useContext } from "react";

export const UiModeContext = createContext({
  uiMode: "LIGHT",
});

export const useUiMode = () => {
  const context = useContext(UiModeContext);
  if (!context) {
    throw new Error("useUiMode must be used within a UiModeProvider");
  }
  return context;
};
